import { css } from '@emotion/css';

export const bulletListStyles = css`
  li::marker {
    font-size: 0.7em;
  }
  li {
    padding-inline-start: 1.6rem;
  }
`;
